import React, { Component } from "react";
import style from "../../assets/css/modules/claims/claims-summary-mobile-row.css";
import Rowstyle from "../../assets/css/modules/claims/claims-summary-mobile-cell.css";
import Contentify from "../../content/Contentify";
import Store from "../../content/Store";

class ClaimsConditionMobileRow extends Component{
    static content = Store.Claims;
    render(){

        return(
            <div className={`row ${style.rowTopMargin}  ${this.props.isMobileDevice? style.rowMarginSides : " "}`}>
                <div className="col-3">
                    <i
                        className={
                        "icon-claims-shield " + style.claimSummaryMobileRowIcon
                        }
                    />
                </div>
                <div className={"col-9 pr-0 " + style.noPaddingLeft  + Rowstyle.claimsSummaryMobileCell}>
                    <div
                        className={
                        "label1 " +
                        Rowstyle.mobileCellLabel +
                        " " +
                        Rowstyle.firstLabelColor +
                        (this.props.isMemberShortfall ? " " + Rowstyle.oval : "")
                        }
                    >
                        {this.props.claimscondition.HealthConditionDescription.charAt(0).toUpperCase() + this.props.claimscondition.HealthConditionDescription.slice(1)}
                    </div>
                    <div className={"label2 " + Rowstyle.mobileCellLabel}>
                        {this.props.content.ClaimNumber + ": "+ this.props.claimscondition.ConditionApprovalNumber}
                    </div>
                    <div className={"label3 " + Rowstyle.mobileCellLabel}>
                        {this.props.content.Lastupdated+" "+new Date(this.props.claimscondition.LastUpdatedDate)?.toLocaleDateString()}
                    </div>
                </div>
            </div>
        );
    }
}

export default Contentify(ClaimsConditionMobileRow);